/* NEO: synchronize the menu drawer state with header presentation styles. */
(() => {
  const neo_initHeader = (root = document) => {
    const neo_headers = root.querySelectorAll?.('.header-wrapper[data-neo-header-position]') || [];

    neo_headers.forEach((neo_header) => {
      if (neo_header.dataset.neoHeaderInitialized === 'true') return;

      const neo_menu = neo_header.querySelector('.menu-drawer-container');
      if (!neo_menu) return;

      const neo_drawer = neo_menu.querySelector('.menu-drawer');
      if (neo_drawer) {
        neo_header.style.setProperty('--neo-menu-drawer-background', getComputedStyle(neo_drawer).backgroundColor);
      }

      /* NEO 2026-10-12: Avoid Safari's sticky synthesized hover on touch devices. */
      const neo_hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
      const neo_setHoverState = (neo_isHovered) => {
        neo_header.classList.toggle('neo-header--hovered', neo_hoverMedia.matches && neo_isHovered);
      };

      neo_header.addEventListener('mouseenter', () => neo_setHoverState(true));
      neo_header.addEventListener('mouseleave', () => neo_setHoverState(false));
      neo_hoverMedia.addEventListener?.('change', () => neo_setHoverState(false));

      const neo_syncMenuState = () => {
        const neo_isMenuOpen =
          neo_menu.hasAttribute('open') || neo_menu.classList.contains('menu-opening');

        neo_header.classList.toggle('neo-header--menu-open', neo_isMenuOpen);
      };

      /* NEO 2026-10-07: Match drawer submenu motion to the PDP accordion. */
      const neo_submenuDetails = neo_header.classList.contains('neo-header--desktop-drawer')
        ? neo_menu.querySelectorAll('.menu-drawer__menu details')
        : [];

      neo_submenuDetails.forEach((neo_details) => {
        const neo_summary = Array.from(neo_details.children).find((neo_child) => neo_child.matches('summary'));
        const neo_submenu = Array.from(neo_details.children).find(
          (neo_child) =>
            neo_child.matches('.menu-drawer__submenu') &&
            !neo_child.classList.contains('menu-drawer__submenu--hidden'),
        );

        if (!neo_summary || !neo_submenu) return;

        neo_summary.setAttribute('aria-expanded', neo_details.hasAttribute('open') ? 'true' : 'false');

        neo_summary.addEventListener(
          'click',
          (event) => {
            /* Preserve the destination of parent menu links; the caret/summary area controls the accordion. */
            if (event.target.closest('a')) return;

            event.preventDefault();
            event.stopImmediatePropagation();

            const neo_isOpening = !neo_details.hasAttribute('open');
            const neo_jquerySubmenu = window.jQuery?.(neo_submenu);

            neo_summary.setAttribute('aria-expanded', neo_isOpening ? 'true' : 'false');
            neo_details.classList.toggle('menu-opening', neo_isOpening);

            if (neo_isOpening) {
              neo_details.setAttribute('open', '');

              if (neo_jquerySubmenu) {
                neo_jquerySubmenu.stop(true, true).hide().slideDown(300);
              }

              return;
            }

            if (neo_jquerySubmenu) {
              neo_jquerySubmenu.stop(true, true).slideUp(300, () => {
                neo_details.removeAttribute('open');
                neo_submenu.style.removeProperty('display');
              });
              return;
            }

            neo_details.removeAttribute('open');
          },
          true,
        );
      });

      const neo_cartLink = neo_header.querySelector('#cart-icon-bubble');
      if (neo_cartLink) {
        neo_cartLink.addEventListener(
          'click',
          (event) => {
            if (!neo_menu.classList.contains('menu-opening')) return;

            const neo_cartDrawer = document.querySelector('cart-drawer');
            if (!neo_cartDrawer || typeof neo_cartDrawer.open !== 'function') return;

            event.preventDefault();
            event.stopImmediatePropagation();

            neo_menu.classList.remove('menu-opening');
            neo_menu.removeAttribute('open');
            neo_menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
            neo_menu.querySelectorAll('details').forEach((neo_details) => {
              neo_details.classList.remove('menu-opening');
              neo_details.removeAttribute('open');
            });
            document.body.classList.remove('overflow-hidden-tablet');
            removeTrapFocus();

            requestAnimationFrame(() => {
              neo_cartDrawer.open(neo_cartLink);
            });
          },
          true,
        );
      }

      const neo_observer = new MutationObserver(neo_syncMenuState);
      neo_observer.observe(neo_menu, { attributes: true, attributeFilter: ['class', 'open'] });

      const neo_newsletterStatus = neo_header.querySelector('[data-neo-header-newsletter-status]');
      const neo_newsletterForm = neo_newsletterStatus?.closest('form');
      const neo_isNewsletterReturn =
        neo_newsletterForm?.id && window.location.hash === `#${neo_newsletterForm.id}`;

      if (neo_newsletterStatus && neo_isNewsletterReturn) {
        const neo_summary = neo_menu.querySelector(':scope > summary');

        if (!neo_menu.hasAttribute('open')) {
          neo_summary?.click();
        }

        window.setTimeout(() => {
          neo_newsletterStatus.focus({ preventScroll: true });
          neo_newsletterStatus.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 100);
      }

      neo_header.dataset.neoHeaderInitialized = 'true';
      neo_syncMenuState();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => neo_initHeader());
  } else {
    neo_initHeader();
  }

  document.addEventListener('shopify:section:load', (event) => neo_initHeader(event.target));
})();
